import { apiText } from '../../lib/api/client';
import type { TradingViewDatafeed } from '../../types/datafeed-api';
import { loadHistoryBars } from './history';
import { ensureSymbol, searchSymbols as searchRemoteSymbols } from './symbols';
import { toLibrarySymbolInfo } from './resolveSymbol';
import { subscribeBars, unsubscribeBars } from './subscribeBars';

export function createDatafeed(options: { includeNineWeek?: boolean } = {}): TradingViewDatafeed {
  const supportedResolutions = options.includeNineWeek
    ? ['1', '5', '15', '30', '60', '240', '1D', '1W', '9W']
    : ['1', '5', '15', '30', '60', '240', '1D', '1W'];

  return {
    onReady(callback) {
      window.setTimeout(() => callback({
        supported_resolutions: supportedResolutions,
        supports_search: true,
        supports_group_request: false,
        supports_marks: false,
        supports_timescale_marks: false,
        supports_time: true,
        exchanges: [
          { value: '', name: 'All Exchanges', desc: '' },
          { value: 'Binance', name: 'Binance', desc: 'Binance' },
          { value: 'NASDAQ', name: 'NASDAQ', desc: 'NASDAQ' },
          { value: 'NYSE', name: 'NYSE', desc: 'NYSE' },
          { value: 'Yahoo Finance', name: 'Yahoo Finance', desc: 'Yahoo Finance' },
        ],
        symbols_types: [
          { name: 'All types', value: '' },
          { name: 'Crypto', value: 'crypto' },
          { name: 'Stock', value: 'stock' },
          { name: 'Forex', value: 'forex' },
        ],
      }), 0);
    },

    getServerTime(callback) {
      apiText('/api/time')
        .then((text) => {
          const time = Number.parseInt(text, 10);
          if (!Number.isNaN(time)) callback(time);
        })
        .catch((err) => console.error('getServerTime:', err));
    },

    searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
      searchRemoteSymbols(userInput, {
        exchange: exchange || undefined,
        type: symbolType && symbolType !== 'all' ? symbolType : undefined,
        limit: 50,
      })
        .then((symbols) => onResultReadyCallback(symbols.map((symbol) => ({
          symbol: symbol.name,
          full_name: symbol.fullName,
          description: symbol.description,
          exchange: symbol.exchange,
          ticker: symbol.name,
          type: symbol.type,
        }))))
        .catch((err) => {
          console.error('searchSymbols:', err);
          onResultReadyCallback([]);
        });
    },

    resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
      ensureSymbol(symbolName)
        .then((symbol) => {
          if (!symbol) {
            onResolveErrorCallback('Symbol not found');
            return;
          }
          window.setTimeout(() => onSymbolResolvedCallback(toLibrarySymbolInfo(symbol)), 0);
        })
        .catch((err) => onResolveErrorCallback(err instanceof Error ? err.message : 'Symbol resolve failed'));
    },

    async getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
      try {
        const { bars } = await loadHistoryBars(symbolInfo, resolution, periodParams);
        onHistoryCallback(bars, { noData: bars.length === 0 });
      } catch (err) {
        onErrorCallback(err instanceof Error ? err.message : 'History load failed');
      }
    },

    subscribeBars,
    unsubscribeBars,
  };
}

export { findSymbol, getLoadedSymbols, ensureSymbol, loadSymbols, normalizeSymbol, searchSymbols } from './symbols';
